export default "__VITE_ASSET__Udp9rX61__"